import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogParams } from '../../../../core/models/dialog-params';
import { handlePluralTranslation } from '../../../../core/utils';

@Component({
  selector: 'ling-dialog-content',
  templateUrl: './dialog-content.component.html',
  styleUrls: ['./dialog-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogContentComponent {
  handlePluralTranslation = handlePluralTranslation;

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogParams) {
    if (!data.confirmButtonType) {
      data.confirmButtonType = 'confirm';
    }
  }
}
